import { AreYouSureModal } from "@tfg/ui"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { CONTACT_WITH_INFORMATION_REQUESTS_ERROR } from "@tfg/types/endpoints/contacts"
import { LibraryResponses } from "@tfg/types/endpoints/library"

import { queryClient } from "~/backend/queryClient"
import {
  findContactsByCreatedByIdQueryKey,
  FindContactsByCreatedByIdResponseDto,
  useDeleteContact,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  isOpen: boolean
  onClose: () => void
  contact: FindContactsByCreatedByIdResponseDto
  user: LibraryResponses.TFGUser | null
}

export const DeleteContactModal = ({
  isOpen,
  onClose,
  contact,
  user,
}: Props) => {
  const { t } = useTranslation("supplier")

  const { mutate: deleteContact } = useDeleteContact({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: findContactsByCreatedByIdQueryKey(
            user?.organization.id ?? ""
          ),
        })
        showSuccessNotification({
          message: t("contactModal.delete.success"),
          title: t("contactModal.delete.success"),
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: t("contactModal.delete.error.title"),
            notificationMessage:
              error.response?.data?.message ===
              CONTACT_WITH_INFORMATION_REQUESTS_ERROR
                ? t("contactModal.delete.error.contactWithInformationRequests")
                : t("contactModal.delete.error.default"),
            showNotification: true,
            error,
          })
        }
      },
    },
  })

  return (
    <>
      <AreYouSureModal
        opened={isOpen}
        onClose={onClose}
        title={t("contactModal.delete.title")}
        confirmText={t("contactModal.delete.confirm")}
        cancelText={t("contactModal.delete.cancel")}
        onConfirm={() => {
          deleteContact({ id: contact.id })
          onClose()
        }}
        areYouSureText={t("contactModal.delete.message")}
      />
    </>
  )
}
